module.exports = __webpack_public_path__ + "static/Gaming Related Work Banner-8d6ca76e9e9f84d6a3c6161278592dc7.png";